import { get, post, put, deleteUrl, postUrl } from './index'

import base from './base'

const api = base + 'gbh-portal/'
const solr = base + 'gbh-solr/'
const system = base + 'gbh-system/'
import li from './li'

const main = {
    getZdType: (type) => { // 用type获取字典
        return get(system + 'dict/queryListByType/' + type)
    },
    getJson: (code, fn) => { // 获取JSON串
        return get(system + 'setting/getByCode/' + code).then(res => {
            fn(res && res.data && res.data.content ? JSON.parse(res.data.content) : '')
        })
    },
    queryDistanceTimeNum: () => { // 查询大会距离时间
        return get(api + 'wechat/queryDistanceTimeNum')
    },
    queryOfficialBannerList: (params) => {  //查询banner列表
        return post(api + 'officialBanner/queryOfficialBannerList', params)
    },
    searchQuery: (params) => {  //搜索
        return post(solr + 'search/query', params)
    },
    queryWebMomentDetail: (uuid) => { // 官网查询专业展精彩瞬间详情
        return get(api + `webExhibit/queryWebMomentDetail/${uuid}`)
    },
    getStatementDetail: () => { // 查询声明详情
        return get(api + `webCommon/getStatementDetail`)
    },
    webBulletinList: (params) => {  //官网查询专业展展会快讯
        return post(api + 'webExhibit/webBulletinList', params)
    },
    getExhibitFileList: (exhibitUuid, code) => { // 查询官网专业展单页附件列表
        return get(api + `webCommon/getExhibitFileList/${exhibitUuid}/${code}`)
    },
    bannerList: (data) => { // 查询官网banner
        return post(api + `webCommon/bannerList`, data)
    },
    webBannerlist: () => { // 官网Banner
        return get(api + `webBanner/list`)
    },
    webLivelist: (num) => { // 查询视频/直播列表
        return get(api + `webLive/list/${num}`)
    },
    webMediaList: (data) => { // 官网查询合作媒体
        return post(api + `webMedia/list`, data)
    },
    webSubscribeadd: (data) => { // 新增订阅
        return post(api + `webSubscribe/add`, data)
    },
}

export default { ...main, ...li }



// WEBPACK FOOTER //
// ./src/api/protal.js